module.exports = __webpack_public_path__ + "img/7-1_06.c9423dda.jpg";